import Login from '../components/login';
import InstancesComponent from '../components/consult/instances';
import ErrorComponent from '../components/consult/error';
import Dashboard from '../components/dashboard';
import DetailComponent from '../components/detail';
import Home from '../components/home';
import EstadoPagoComponent from '../components/consult/estadoPago';
import DespachoDigitalComponent from '../components/report/despachoDigital'
import DespachoDigitalConfigComponent from '../components/config/despachoDigital'
import MessengerComponent from '../components/mail'

const routes = [
    { exact: true,
      path: '/', 
      component: Login 
    },
    {
      component: Home,
      routes: [
        {
          exact: true,
          path: '/home',
          strict: true,
          component: Dashboard
        },
        {
          exact: true,
          path: '/home/detail/:idOrder?/:engineId?',
          strict: true,
          component: DetailComponent
        },
        {
          exact: true,
          path: '/home/consult/error',
          strict: true,
          component: ErrorComponent
        },
        {
          exact: true,
          path: '/home/consult/instances',
          strict: true,
          component: InstancesComponent
        },
        {
          exact: true,
          path: '/home/consult/estadoPago',
          strict: true,
          component: EstadoPagoComponent
        } ,
        {
          exact: true,
          path: '/home/report/despachoDigital',
          strict: true,
          component: DespachoDigitalComponent
        } ,
        {
          exact: true,
          path: '/home/config/despachoDigital',
          strict: true,
          component: DespachoDigitalConfigComponent
        } ,
        {
          exact: true,
          path: '/home/config/messenger',
          strict: true,
          component: MessengerComponent
        }
      ]
    }
  ];

  export default routes;
